export default class Local {
  static getEnvironmentId(): string {
    return localStorage.getItem('environmentId') || '';
  }

  static setEnvironmentId(environmentId: string): void {
    localStorage.setItem('environmentId', environmentId);
  }

  static clear(): void {
    localStorage.removeItem('environmentId');
  }
}
